import { render, staticRenderFns } from "./iconBase.vue?vue&type=template&id=3f9efa62&scoped=true"
import script from "./iconBase.vue?vue&type=script&lang=js"
export * from "./iconBase.vue?vue&type=script&lang=js"
import style0 from "./iconBase.vue?vue&type=style&index=0&id=3f9efa62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9efa62",
  null
  
)

export default component.exports